import { T } from "@supersig/validate";
import { canvasUiColorTypeValidator } from "./TLColor";
import { vec2dModelValidator } from "./geometry-types";
/**
 * The scribble states used by tldraw.
 *
 *  @public */ export const TL_SCRIBBLE_STATES = new Set([
    "starting",
    "paused",
    "active",
    "stopping"
]);
/** @internal */ export const scribbleValidator = T.object({
    id: T.string,
    points: T.arrayOf(vec2dModelValidator),
    size: T.positiveNumber,
    color: canvasUiColorTypeValidator,
    opacity: T.number,
    state: T.setEnum(TL_SCRIBBLE_STATES),
    delay: T.number,
    shrink: T.number,
    taper: T.boolean
});
